export default "__VITE_ASSET__Cc1rPbwI__"